module.exports = __webpack_public_path__ + "img/game_BG.585f4373.jpg";